export default {
  headerTile: 'Everything you need to know about your trip',
  contact: 'Contact',
  noContacts: 'There are no contacts',
  tourResume: 'Tour resume',
  extraField: 'Extras',
  day: 'Day',
  tour: 'Tour',
  flight: 'Flight',
  transfer: 'Transfer',
  transportLuggage: 'Transport of your luggage',
  stageNumOriginDestination: 'Stage: { origin } - { destination }',
  distanceNumberKm: 'Distance: { number } Km',
  notSelectTransfer: 'You have not selected a transfer yet',
  notSelectTransport: 'You have not selected a transport yet',
  accommodation: 'Accommodation',
  information: 'Information',
  quantityNights: 'No nights | One night | { quantity } nights',
  totalPrice: 'Total Price',
  whatToDoLocation: 'What to do in { location }',
  urlToLocationMap: 'Url to { location } map',
  urlToLocationWeb: 'Url to { location } website',
  website: 'Website',
  map: 'Map',
  linkAboutDay: 'Link about the day',
  guidebookLocation: 'Guidebook: { location }',
  viewWebsite: 'View website',
  viewGoogleMaps: 'View in Google Maps',
  stageInformation: 'Stage information',
  dayInformation: 'Day information',
  guidebookOfLocation: 'Guidebook of { location }',
  linkGoogleMapsResource: 'Link to Google Maps of { resource }',
  linkResourceWebsite: 'Link to { resource } website',
  address: 'Address',
  noResourcesLocation: 'No resources have been added to this location',
  viewWebsiteOfSupplier: 'View website of { supplier }',
  urlGoogleMapsOfSupplier: 'Url to Google Maps of { supplier }',
  travelInformation: 'Travel information',
  pricePerPerson: 'Price per person',
  downloadErrorText: 'An error occurred while downloading',
  pricePerUnit: '€/unit',
  printTravelBook: 'Print Travel Book',
  preparedFor: 'Prepared For',
  reference: 'Reference',
  beforeTrip: 'Before Your Trip',
  luggage: 'Luggage',
  afterTrip: 'Post Journey Info',
  supportContacts: 'Support & Contacts',
  needToKnow: 'Need to know',
  inclusionsExclusions: "What's Included & Not Included",
  whatsIncluded: "What's Included",
  whatsNotIncluded: "What's Not Included",
  optionalExtras: 'Optional Extras',
  readyToAdventure: 'Ready to Adventure?',
  finalizeReservation: 'Finalize your reservation and lock in your personalized itinerary today.',
  whatsappSpecialist: 'WhatsApp Specialist',
  requestReservation: 'Request Reservation',
  itineraryNotFound: 'Itinerary Not Found',
  itineraryNotFoundDescription: "We couldn't retrieve this itinerary. It may have expired or the link is invalid.",
  returnHome: 'Return Home',
  featuredImage: 'Trip Featured Image',
  displayMode: 'Display mode',
  colorMode: 'Color',
  darkMode: 'Dark',
  km: 'km',
  service: 'Service',
  services: 'Services',
  viewMore: 'View More',
  viewLess: 'View Less',
  hotel: 'Accommodation',
  activity: 'Activity',
  transport: 'Transport',
  general_information: 'General Information',
  stage_information: 'Stage Information',
};
